module.exports = __webpack_public_path__ + "static/media/DqEveryChildExhibitionHero.fa16f968.jpg";